export const getParentSelector = () =>
  document.querySelector('#modules-merchant-products') || document.querySelector('#modules');



// WEBPACK FOOTER //
// ./src/helpers/modal.js